import React, {Fragment} from 'react'
import {Button, Collapse} from 'antd';
import {Link} from "react-router-dom";

const { Panel } = Collapse;

export default function FAQ(props) {
    let entries = [{
        question: 'What is the price?',
        answer: <span>I believe all authors deserve a professional proofreading and our prices are very affordable. Prices start from &#163;4.99 per 1000 words.  For more detailed pricing, click on <Link to="/request?service=fiction">Request to proofread</Link> & input the number of words.. </span>,
        type: ['fiction'],
    }, {
        question: 'What is the price?',
        answer: <span>I believe all authors deserve a professional proofreading and our prices are very affordable. Prices start from &#163;16.50 per 1000 words.  For more detailed pricing, click on <Link to="/request?service=thesis">Request to proofread</Link> & input the number of words.. </span>,
        type: ['thesis', ],
    }, {
        question: 'What is the price?',
        answer: <span>I believe all authors deserve a professional proof-listen for their audiobook and our prices are very affordable. Prices start from &#163;14.99 per 1000 words.  For more detailed pricing, click on <Link to="/request?service=audiobook">Request to proof-listen</Link> & input the number of words.. </span>,
        type: ['audiobook', ],
    }, {
        question: 'What would proofreading work of fiction include?',
        answer: <span>When I proofread your work of fiction, I aim to correct:
            <ol>
                <li>grammar</li>
                <li>spelling</li>
                <li>paragraph-grouping</li>
                <li>suggest alternative appropriate word choice, where necessary</li>
                <li>punctuations</li>
            </ol></span>,
        type: ['fiction'],
    }, {
        question: 'Will you yourself proofread?',
        answer: <span>Yes, I shall personally look at your document. Rest assured, having formally studied literature and being a life-long bookworm, I am the perfect fit for you.</span>,
        type: ['fiction'],
    }, {
        question: 'What kind of fiction do I check?',
        answer: <span>I accept:<br />
        Creative writing university dissertation/ essay <br />
        Novel<br />
        Novella<br />
        Chapters/ extract from a bigger work of fiction<br />
        Picture book<br />
        Drama script<br />
        Graphic novels<br />
        Poems<br />
        Anthology<br />
        Omnibus<br />
        Short stories<br />
        </span>,
        type: ['fiction'],
    }, {
        question: 'Do you only check MLA formats?',
        answer: <span>Yes, I only check in MLA format.</span>,
        type: ['thesis'],
    }, {
        question: 'Will footnotes be proofread too?',
        answer: <span>Yes, footnotes will be proofread too.</span>,
        type: ['thesis'],
    }, {
        question: 'Will you yourself proofread?',
        answer: <span>Yes, I shall personally look at your document. Rest assured, having formally studied literature and being a life-long bookworm, I am the perfect fit for you.</span>,
        type: ['thesis'],
    }, {
        question: 'How do you send me the audio file?',
        answer: <span>On the payment page you have an option to upload your manuscript and the audiofile. MSWord, .pdf , .mp3, .m4a are accepted.</span>,
        type: ['audiobook'],
    }, {
        question: 'How long will it take?',
        answer: <span>It will take upto 10 working days, depending on the length of the audiobook.</span>,
        type: ['audiobook'],
    }, {
        question: 'What kind of fiction do I check?',
        answer: <span>I accept:<br />
        Creative writing university dissertation/ essay <br />
        Novel<br />
        Novella<br />
        Chapters/ extract from a bigger work of fiction<br />
        Picture book<br />
        Drama script<br />
        Graphic novels<br />
        Poems<br />
        Anthology<br />
        Omnibus<br />
        Short stories<br />
        </span>,
        type: ['audiobook'],
    }, {
        question: 'What is the price?',
        answer: <span>&#163;14.99 for one audiobook narration.</span>,
        type: ['narration'],
    }, {
        question: 'Are all kinds of fiction accepted?',
        answer: <span>Only picture books will be accepted.</span>,
        type: ['narration'],
    }, {
        question: 'Are there any genre restrictions?',
        answer: <span>All genres are accepted.</span>,
        type: ['narration'],
    }, {
        question: 'How long will it take?',
        answer: <span>A maximum of 2 working days.</span>,
        type: ['narration'],
    }, {
        question: 'What is the process?',
        answer: <span>On the payment page you have an option to upload your manuscript/ ebook (MSWord/ .pdf documents are accepted). I shall then record the audiobook and then email it to you in '.m4a' format.</span>,
        type: ['narration'],
    },

    {
        question: 'What do you check and the price?',
        answer: <span>
        1) Dilemma between which word/ phrase is more suitable in a sentence: &#163;9.99<br />
        2) Are the names of the  characters appropriate? &#163;9.99<br />
        3) Is the chapter title appropriate? &#163;9.99<br />
        4) Is the title of the book good enough? &#163;9.99<br />
        5) Character development: &#163;14.99<br />
        6) Plot development: &#163;14.99<br />
        7) Write a book title: &#163;14.99<br />
        8) Write a chapter title: &#163;14.99
        </span>,
        type: ['dilemma'],
    }, {
        question: 'How will I help?',
        answer: <span>I shall provide a written email response*.<br /><br />
        <b>*Comments may be a max of two-line response</b>, depending on the nature of the comment.</span>,
        type: ['dilemma'],
    }, {
        question: 'Will you creatively write for me while editing?',
        answer: <span>For character and plot development, no, I shall simply be pointing out if I feel the plot is too fast paced or if the plot line is too confusing etc .. I shall merely indicate these technicalities to you. I will not be creatively suggesting or writing anything. However for title or character name appropriateness, I shall make suggestions of other possibilities, if needs be.</span>,
        type: ['dilemma'],
    }, {
        question: 'What kind of fiction do I check?',
        answer: <span>I accept:<br />
        Creative writing university dissertation/ essay <br />
        Novel<br />
        Novella<br />
        Chapters/ extract from a bigger work of fiction<br />
        Picture book<br />
        Drama script<br />
        Short stories
        <br /><br />
        Graphic novels and poems will not be looked into
        </span>,
        type: ['dilemma'],
    }, {
        question: 'How long would it take to deliver the document?',
        answer: <span>It will take a maximum of six working days however, shorter works of fiction will be delivered quicker.</span>,
        type: ['dilemma'],
        },{
        question: 'Will you yourself help me with my writer\'s dilemma?',
        answer: <span>Yes, I shall personally look at your document. Rest assured, having formally studied literature and being a life-long bookworm, I am the perfect fit for you.</span>,
        type: ['dilemma'],
    },

    {
        question: 'What is a blurb?',
        answer: <span>Do you remember the time before you buy a book, you turn to the back-cover to read that short description which gives you a gist of the plot but still reserves enough suspense for you to get enticed and purchase the book? Well, that's a blurb. Your book equally deserves a stellar blurb.</span>,
        type: ['blurb'],
    },  {
        question: 'What is the price?',
        answer: <span>&#163;9.99 for up to 1000 words<br />
            &#163;14.99 for up to 10000 words<br />
            &#163;29.99 for up to 50000 words<br />
            &#163;39.99 for up to 100000 words<br />
            &#163;49.99 for up to 200000 words</span>,
        type: ['blurb'],
    },  {
        question: 'How long will you take to finish the blurb?',
        answer: <span>It will take a maximum of six working days, however, shorter works of fiction will be delivered quicker.</span>,
        type: ['blurb'],
    },  {
        question: 'How long will your blurb be?',
        answer: <span>Your blurb can be anywhere between 1-5 sentences.</span>,
        type: ['blurb'],
    },  {
        question: 'Will you use quotes from my work of fiction?',
        answer: <span>Yes, there is a possibility that I quote a phrase/ sentence from your piece of work that I feel suitable to brandish on the blurb.</span>,
        type: ['blurb'],
    },  {
        question: 'What kind of fiction do I do blurbs for?',
        answer: <span>I accept all works of fiction:<br />
        Novel<br />
        Novella<br />
        Picture book<br />
        Drama script<br />
        Short stories
        <br /><br />
        Graphic novels and poems will not be looked into
        </span>,
        type: ['blurb'],
    }, {
        question: 'What is the price?',
        answer: <span>&#163;14.99</span>,
        type: ['review'],
    }, {
        question: 'How long will you take to finish the back-cover review?',
        answer: <span>It will take a maximum of six working days however, shorter works of fiction will be delivered quicker .</span>,
        type: ['review'],
    }, {
        question: 'What will you quote the review from?',
        answer: <span>You are free to use from the follows:<br />
            <ol>
                <li>Vabis</li>
                <li>Vabis D.</li>
                <li>Vabis (MA Literature)</li>
                <li>Vabis (Founder of Vabis' Literature Services)</li>
                <li>Vabis' Literature Service</li>
                <li>literatureproofreading.com</li>
                <li>www.literatureproofreading.com</li>
                <li>https://www.literatureproofreading.com</li>
                <li>Or you can customize by using a mix of the above however, the quote should always be identified to me and no other. Using a pseudonym or other name is not permitted.</li>
            </ol>
        </span>,
        type: ['review'],
    }, {
        question: 'What kind of fiction do I do back-cover reviews for?',
        answer: <span>I accept all works of fiction:<br />
        Novel<br />
        Novella<br />
        Short Story<br />
        Picture book<br />
        Drama script
        <br /><br />
        Graphic novels and poems will not be looked into
        </span>,
        type: ['review'],
    }, {
        question: 'Are there any genre restrictions?',
        answer: <span>All genres are accepted, except adult horror fiction.</span>,
        type: ['blurb', 'review', 'fiction', 'dilemma'],
    }, {
        question: 'Will you use British or American english while proofreading?',
        answer: <span>Whilst proofreading, spellings will be corrected with a mix of British and American english.</span>,
        type: ['fiction', 'thesis'],
    }, {
        question: 'What language do I accept documents in?',
        answer: <span>I accept documents only in English.</span>,
        type: ['general'],
    }, {
        question: 'How do I upload my document?',
        answer: <span>On the payment page, there is an option to upload your document. Only MS Word files are accepted.</span>,
        type: ['fiction', 'thesis', 'blurb', 'dilemma', 'review'],
    }, {
        question: 'How will you make changes while proofreading?',
        answer: <span>I will use Word Document Track Change. The altered document will be emailed to you, so keep an eye on your inbox and spam folder, just in case.</span>,
        type: ['fiction', 'thesis'],
    }, {
        question: 'Can I send my document from anywhere in the world?',
        answer: <span>Yes, I cater to a global audience.</span>,
        type: ['general'],
    }, {
        question: 'Do you offer express delivery service?',
        answer: <span>No, there is no express service as of yet but there is a heavy possibility you can get your documents sooner than the time quoted.</span>,
        type: ['general'],
    }, {
        question: 'Is my manuscript safe with you?',
        answer: <span>Yes, your documents are in safe hands and breach of confidentiality and copyright are taken very seriously. Your documents are never shared with anyone.</span>,
        type: ['general'],
    }, {
        question: 'Time to process the document?',
        answer: <span>For 1000 words or less it will take 2 working days.<br />
        For 1001- 10000 words, it will take 3 working days.<br />
        For 10001- 30000 words, it will take 6 working days.<br />
        For 30001- 50000 words, it will take 7 working days.<br />
        For 50001-100000 words, it will take 14 working days.<br />
        For 100001-200000 words, it will take 21 working days.<br />
        For anything over 200001 words, please email me so we can personally talk about the length it would take to proofread.
    </span>,
        type: ['thesis', 'fiction', 'audiobook'],
    }, {
        question: 'Do you allow under 18\'s to apply for any of your services?',
        answer: <span>Whilst acknowledging that child authors exist, you must be 18 years or over to purchase these services.</span>,
        type: ['general'],
    }, {
        question: 'What qualifications do you have?',
        answer: <span>I have a BA in English (2016-2019) with first class distinction. I also have an MA in Literature (specialising in Children's literature) (2020-2021) with Merits from Roehampton University, London, UK.</span>,
        type: ['general'],
    }];

    return (
        <Fragment>
            <br />
            <br />
            <br />
            <Collapse defaultActiveKey={Object.keys(entries)}>
                {entries.filter(entry => entry.type.includes(props.topic)).map(({ question, answer, key }, keyId) =>
                    <Panel header={question} key={keyId}>
                        {answer}
                    </Panel>
                )}
            </Collapse>
        </Fragment>
    )

}
